import type { ReactNode } from "react";
import { Reveal } from "@/components/Reveal";

/** Shared prose shell for the legal pages (Disclosures, Privacy, Terms). */
export function LegalLayout({
  title,
  updated,
  intro,
  children,
}: {
  title: string;
  updated: string;
  intro: string;
  children: ReactNode;
}) {
  return (
    <section className="bg-background">
      <div className="mx-auto max-w-3xl px-6 py-16 lg:px-10">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-accent">
            Legal
          </p>
          <h1 className="mt-3 font-serif text-4xl font-semibold leading-tight md:text-5xl">
            {title}
          </h1>
          <p className="mt-3 text-sm text-muted-foreground">Effective {updated}</p>
          <p className="mt-6 text-lg leading-relaxed text-muted-foreground">{intro}</p>
          <div className="mt-10 space-y-8">{children}</div>
        </Reveal>
      </div>
    </section>
  );
}

export function LegalSection({
  heading,
  children,
}: {
  heading: string;
  children: ReactNode;
}) {
  return (
    <div>
      <h2 className="font-serif text-2xl font-semibold leading-snug text-foreground">
        {heading}
      </h2>
      <div className="mt-3 space-y-3 text-base leading-relaxed text-muted-foreground">
        {children}
      </div>
    </div>
  );
}
